// @ts-nocheck
import { Column } from 'react-table'
import { TitleCell } from './TitleCell'
import { UserCustomHeader } from './CustomHeader'
import moment from 'moment';
import { ActionCell } from './ActionCell';
import { TextCell } from './TextCell';


const inventoryListColumns: ReadonlyArray<Column<User>> = [
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Sku' className='min-w-50px' />
    ),
    id: 'sku',
    Cell: ({ ...props }) => <TextCell userObj={props.data[props.row.index]?.sku} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='EAN' className='min-w-50px' />
    ),
    id: 'ean',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.ean} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Quantità disponibile' className='min-w-50px' />
    ),
    id: 'totalQuantity',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.totalQuantity} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Prezzo Vendita' className='min-w-50px' />
    ),
    id: 'prezzoVendita',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.prezzoVendita} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Costo Articoli' className='min-w-50px' />
    ),
    id: 'costoArticoli',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.costoArticoli} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='IVA' className='min-w-50px' />
    ),
    id: 'iva',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.iva} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Margine previsto del prodotto (%)' className='min-w-50px' />
    ),
    id: 'productTargetMargin',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.productTargetMargin} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Ultimo Aggiornamento' className='min-w-50px' />
    ),
    id: 'updatedAt',
    Cell: ({ ...props }) => <TitleCell userObj={moment(props.data[props.row.index]?.updatedAt).format("YYYY-MM-DD")} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Action' className='min-w-75px' />
    ),
    id: 'action',
    Cell: ({ ...props }) => <ActionCell user={props.data[props.row.index]} />,
  },
]

export { inventoryListColumns }
